<template>
    <div>
        <draggable
            class="list-group"
            tag="ul"
            v-model="listGallery"
            v-bind="dragOptions"
            @start="isDragging = true"
            @end="isDragging = false">
            <transition-group type="transition" name="flip-list">
            <li class="card list-group-item p-2 ml-2 mr-2 mb-5" v-for="element in listGallery" :key="element.id">
                <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end">
                    <div class="text-primary">
                        <a class="link" @click="deleteImage(element)">
                            <i class="fal fa-trash"></i>
                        </a>
                    </div>
                </div>
                <i :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click="element.fixed = !element.fixed" aria-hidden="true"></i>
                <img class="img-fluid img-item" :src="getImage(element.path)"/>
            </li>
            </transition-group>
        </draggable>
        <div class="mt-3">
            <vue-dropzone id="dropLogo" ref="dropzone" class="text-center mt-3 mb-5" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
        </div>
        <div class="border-top text-left mt-5 mb-3">
            <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed mt-3" @click="submitGallery">{{$t('button_link.save')}}</button>
        </div>
    </div>
</template>
<script>
import vueDropzone from "vue2-dropzone";
import draggable from "vuedraggable";
export default {
    name: 'infoGallery',
    components:{
        vueDropzone, draggable
    },
    props:{
        gallery: { type: Array}
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    data(){
        return{
            listGallery: [],
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },
        }
    },
    methods:{
        closeModal(){
            this.$parent.$parent.isModalShow = false
        },
        getImage(path){
            return path
        },
        deleteImage(item){
            this.listGallery = this.listGallery.filter(obj=> obj.id != item.id)
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.parent.$parent.setModal(this, false, true, this.$msg.IMG_UPLOAD_ERROR);
            }else{
                this.listGallery.push({
                    order: this.listGallery.length + 1,
                    id: 'gallery_' + this.listGallery.length + 1,
                    path: response.path
                })
            }
            this.listGallery.sort((a, b) => a.order - b.order);
            this.$refs.dropzone.removeFile(file)
        },
        submitGallery(){
            var data = []
            for(var i=0; i<this.listGallery.length; i++){
                data.push(this.listGallery[i].path)
            }
            this.$emit('submitGallery', {gallery: data});
        }
    },
    mounted(){
        let $vm = this;
        for(var i=0; i<$vm.gallery.length; i++){
            $vm.listGallery.push({
                order: i,
                id: 'gallery_' + i,
                path: $vm.gallery[i]
            })
        }
        $vm.listGallery.sort((a, b) => a.order - b.order);
    },
}
</script>
<style scoped>
.img-item{
    width: 13em;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    display: inline-block;
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}
</style>